const e={DELETE:"delete",ALIGNMENT:"alignment",SETTINGS:"settings",REPLACE:"replace",LINK:"link",SIZE:"size",SEPARATOR:"separator"};export{e as default};
//# sourceMappingURL=pluginToolbarButtonsIds.js.map
